var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 64,
    fill: "#3678f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.883,24.477a2.43,2.43,0,0,0-1.965-1.687l-20.153-3.08L35.886,1.383A2.461,2.461,0,0,0,33.69,0a2.409,2.409,0,0,0-2.2,1.349L22.321,19.538l-20.2,2.775A2.446,2.446,0,0,0,.724,26.479l14.505,14.31-3.61,20.04a2.433,2.433,0,0,0,.947,2.4,2.468,2.468,0,0,0,2.589.205L33.275,54.1l17.972,9.61A2.544,2.544,0,0,0,52.4,64a2.39,2.39,0,0,0,1.425-.455,2.451,2.451,0,0,0,1-2.39L51.533,41.067l14.718-14.09a2.437,2.437,0,0,0,.632-2.5",
    transform: "translate(-0.001 -0.001)",
    fill: "#3678f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d9c99b173bbdede2c5b58a798d6fa23a.svg";
export { ForwardRef as ReactComponent };